module.exports = __webpack_public_path__ + "static/img/301.cc28cf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201029/301.jpg
// module id = /HeF
// module chunks = 0